import { OctagonAlert } from 'lucide-react'

import { cn } from '../../utils/cn'
import { Card, CardContent } from './card'

interface ErrorProps {
  children: React.ReactNode
  /** Compact variant: smaller text, tighter padding and a smaller icon. */
  small?: boolean
  className?: string
}

/** A red error card with an alert icon. Shared across the app. */
export function Error({ children, small, className }: ErrorProps) {
  return (
    <Card
      className={cn(
        'text-destructive bg-destructive/5 border-none font-medium shadow-none',
        small && 'py-4 text-sm font-normal',
        className
      )}
    >
      <CardContent className={cn('flex items-start gap-3', small && 'px-4')}>
        <div
          className={cn(
            'bg-surface flex shrink-0 items-center justify-center rounded-full',
            small ? 'size-8' : 'size-10'
          )}
        >
          <OctagonAlert className={cn('text-destructive shrink-0', small ? 'size-4' : 'size-5')} />
        </div>
        <div>{children}</div>
      </CardContent>
    </Card>
  )
}
